import React from 'react'

export default () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M14.46 11.18L7.5 7.13998C6.84 6.74998 6 7.22998 6 7.99998V16.09C6 16.86 6.84 17.34 7.5 16.95L14.46 12.91C15.12 12.52 15.12 11.57 14.46 11.18Z"
      fill="#2E2D37"
    />
    <path
      d="M17 16.97C16.45 16.97 16 16.52 16 15.97V8.12C16 7.57 16.45 7.12 17 7.12C17.55 7.12 18 7.57 18 8.12V15.98C18 16.53 17.55 16.97 17 16.97Z"
      fill="#2E2D37"
    />
  </svg>
)
